import { createArrayWithLength } from '@/lib/utils'
import { MyText } from '@components/storeMap/floor/3d/components/Text'
import { isDevMode, isIntegrationMode } from '@utils/env'

// Length should match axesHelper args
const AXIS_LENGTH = 5
const LABEL_OFFSET = 1.5
const FONT_SIZE = 0.5

const axisLabels = createArrayWithLength(6, i => i * 5)

export default function AxisLabels3D() {
  if (!isDevMode && !isIntegrationMode) {
    return null
  }

  return (
    <group >
      <axesHelper args={[25]} />

      {/* X axis (red) */}
      <MyText
        position={[AXIS_LENGTH + LABEL_OFFSET, 0.2, 0]}
        color="#ff0000"
        fontSize={1}
        anchorX="center"
        anchorY="middle"
        outlineColor="#000"
        outlineWidth={0.01}
      >
        X
      </MyText>

      {axisLabels.map((label) => {
        return (
          <MyText
            key={label}
            position={[label, 0.5, 0]}
            color="#ff0000"
            fontSize={FONT_SIZE}
            anchorX="center"
            anchorY="middle"
            outlineColor="#000"
            outlineWidth={0.01}
          >
            {label}
          </MyText>
        )
      })}

      {/* Y axis (green) */}
      <MyText
        position={[0, AXIS_LENGTH + LABEL_OFFSET, 0]}
        color="#00ff00"
        fontSize={1}
        anchorX="center"
        anchorY="middle"
        outlineColor="#000"
        outlineWidth={0.01}
      >
        Y
      </MyText>

      {axisLabels.map((label) => {
        return (
          <MyText
            key={label}
            position={[0, label, 0]}
            color="#0f0"
            fontSize={FONT_SIZE}
            anchorX="center"
            anchorY="middle"
            outlineColor="#000"
            outlineWidth={0.01}
          >
            {label}
          </MyText>
        )
      })}

      <MyText
        position={[0, 0.5, AXIS_LENGTH + LABEL_OFFSET]}
        color="#0000ff"
        fontSize={1}
        anchorX="center"
        anchorY="middle"
        outlineColor="#000"
        outlineWidth={0.01}
      >
        Z
      </MyText>

      {axisLabels.map((label) => {
        return (
          <MyText
            key={label}
            position={[0, 0.5, label]}
            color="#00f"
            fontSize={FONT_SIZE}
            anchorX="center"
            anchorY="middle"
            outlineColor="#000"
            outlineWidth={0.01}
          >
            {label}
          </MyText>
        )
      })}
    </group>
  )
}
